import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Grace.css';

const Grace = () => {
    return (
        <div>
            <Container>
                <Col>
                    <h1>Grace</h1>
                    <h3> Grace Fan Profile</h3>
                    <p>
                        Specialized in doing international trading between China to South Africa from 2008 up to now. Products verify from Power transformers, cables, solar lights and solar relative products, 3d printing furnitures, office and household furnitures, construction materials, outdoor playground equipment, giant waterpark  rides, cylinders, electronic equipment, ect.
                    </p>
                </Col>
                <Row>
                    <Col className="profile-images" lg="4">
                        <img src="/assets/images/image_11.jpeg" />
                        <p>Business visit with Chinese Former Embassador Mr.Lin Songtian</p>
                    </Col>
                    <Col className="profile-images" lg="4">
                          <img src="/assets/images/image_03.jpeg" />
                        <p>With MEC of Gauteng Province, South Africa</p>
                    </Col>
                    <Col className="profile-images" lg="4">
                          <img src="/assets/images/image_11.jpeg" />
                        <p>With MEC of Gauteng Province, South Africa</p>
                    </Col>

                    <Col className="profile-images" lg="4">
                          <img src="/assets/images/image_07.jpeg" />
                        <p> With the Wife of Former President Jacob Zuma</p>
                    </Col>
                    <Col className="profile-images" lg="4">
                          <img src="/assets/images/image_08.jpeg" />
                        <p> With officers from Mogale City Local Municipality</p>
                    </Col>
                    <Col className="profile-images" lg="4">
                          <img src="/assets/images/image_06.jpeg" />
                        <p> Friends and families from South Africa</p>
                    </Col>
                    <Col className="profile-images" lg="4">
                          <img src="/assets/images/image_01.jpeg" />
                        <p>Conducting inspection at Chinese factory</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Grace;